import TextModal from '../../../components/molecules/modals/text-modal.vue'
import FeedbackError from '../../../components/atoms/feedbacks/feedback-error.vue'
import PageHeadline from '../../../components/molecules/headlines/PageHeadline.vue'

export default {
  components: {
    TextModal,
    FeedbackError,
    PageHeadline
  },
  data() {
    return {
      gift_code: '',
      showableErrorFeedback: false,
      errorMessage: '',
      isModalActive: false,
      modalText: {
        title: '確認',
        caption:
          'ギフトコードが適用されていませんがこのまま離れてよろしいですか？適用する場合はキャンセルして「利用する」ボタンを押してください。',
        primaryButton: 'このまま離れる',
        cancelButton: 'キャンセル'
      },
      showableAccordion: true
    }
  },
  mounted() {
    const errorMessage = document.querySelector('.error_message')
    if (errorMessage) {
      this.showableErrorFeedback = true
      this.errorMessage = 'ギフトコードにエラーがあります'
    }
    const giftCodeHtml = document.querySelector(
      '#gift_code_serial_form_gift_code'
    ).outerHTML
    const giftCode = giftCodeHtml.match(/value="(.*?)"/)

    if (giftCode) {
      this.gift_code = giftCode[1]
    }

    // 事前にギフトコードの高さをセットしないとアコーディオンが意図通りの挙動をしないため
    const giftCodeList = document.querySelector(
      '.gift-code-list__content .expand-tl-list__ul'
    )
    if (giftCodeList) {
      giftCodeList.style.height = giftCodeList.scrollHeight + 'px'
    }
  },
  computed: {
    isInputted() {
      return this.gift_code.length !== 0
    }
  },
  methods: {
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showModal() {
      this.isModalActive = true
    },
    closeModal() {
      this.isModalActive = false
    },
    onClickPrimaryButton(url) {
      location.href = url
      this.closeModal()
    },
    onClickBack(url) {
      // NOTE: ブラウザバックでこの画面にきたとき、this.gift_codeは空だがinputフィールドには値があるときがあるので、その対応
      const giftCodeForm = document.querySelector(
        '#gift_code_serial_form_gift_code'
      )
      if (giftCodeForm && giftCodeForm.value) {
        this.gift_code = giftCodeForm.value
        this.showModal()
        return
      }
      location.href = url
    },
    showAccordion() {
      this.showableAccordion = !this.showableAccordion
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    }
  }
}
